import { apiPublic, apiAuth, apiAuthPublic } from "./api/clients";
import "./api/interceptors";

export default class APIService {

  static async listGhosts() {
    const res = await apiPublic.get("ghosts/");
    return res;
  }

  static async login(email, password) {
    const res = await apiAuthPublic.post("login/", {
      email,
      password,
    });
    return res;
  }

  static async createGuest() {
    const res = await apiAuthPublic.post("anonymous_token/");
    return res;
  }

  static async register(email, password, username) {
    const res = await apiAuthPublic.post("register/", {
      email,
      password,
      username
    });
    return res;
  }

  static async verifyAccount(token) {
    const res = await apiAuthPublic.post(`register/verify/`,{
      token
    });
    return res;
  }

  static async ghostAnswer(id) {
    const res = await apiAuth.get(`ghosts/answer/${id}/`);
    return res;
  }
  static async getGhostAnswers(){
    const res = await apiAuth.get("ghosts/answers/");
    return res;
  }

  static async refreshToken(){
    const res = await apiAuthPublic.post("login/refresh/");
    return res;
  }
  
  static async logout(){
    const res = await apiAuthPublic.post("logout/");
    return res;
  }

  static async getDailyRoom(){
    const res = await apiAuth.get("places/get_daily/");
    return res;
  }
  
  static async roomAnswer(id){
    const res = await apiAuth.get(`places/answer/${id}/`);
    return res;
  }

  static async getRoomAnswers(){
    const res = await apiAuth.get("places/answers/");
    return res;
  }

  static async getGhostScores(){
    const res = await apiAuth.get("scores/top_ghost/");
    return res;
  }
  static async getGhostStreak(){
    const res = await apiAuth.get("scores/ghost_streak/");
    return res;
  }

  static async getRoomScores(){
    const res = await apiAuth.get("scores/top_room/");
    return res;
  }

  static async getRoomStreak(){
    const res = await apiAuth.get("scores/room_streak/");
    return res;
}
}